import { UsersDomain, WorkflowActionData, WorkflowActionInfo } from "lib/api";

export interface DialogContentProps {
  onCancel?: () => void;
  onApply?: (data: WorkflowActionData) => void;
  actionType?: WorkflowActionInfo;
  initialValues?: WorkflowActionData;
  skipTemplateLoad?: boolean;
}

export const userPredicate = (
  user: UsersDomain,
  searchString: string
): boolean => {
  const expression = new RegExp(
    searchString.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"),
    "i"
  );
  return (
    (user?.name != null && expression.test(user.name)) ||
    (user?.surname != null && expression.test(user.surname)) ||
    (user?.email != null && expression.test(user.email))
  );
};
